function DarkStoreItem() {
    return(
        <div className="card">
             <div className="card-header">Store</div>
                <div className="card-body">
                    <button type="button" className="btn btn-primary btn-lg">New Genres: 3 Silver CobBucks</button>
                    <button type="button" className="btn btn-primary btn-lg">2x Brass CobBucks for an hour: 1 Silver CobBucks</button>
                    <button type="button" className="btn btn-primary btn-lg">Access to Hangman 2: 10 Gold CobBucks</button>
                    <button type="button" className="btn btn-primary btn-lg">Ad-Free: 50 Silver CobBucks</button>
                </div>
        </div>
    )
}

export default DarkStoreItem;